document.addEventListener("DOMContentLoaded", function () {
  const set1 = document.querySelectorAll(".logo-set-1 img");
  const set2 = document.querySelectorAll(".logo-set-2 img");
  const container1 = document.querySelector(".logo-set-1");
  const container2 = document.querySelector(".logo-set-2");

  async function showSet(set, container) {
    container.style.opacity = 1;
    container.style.pointerEvents = 'auto';

    for (let i = 0; i < set.length; i++) {
      set[i].classList.add("logo-fade-in");
      set[i].classList.remove("logo-fade-out");
      await new Promise(resolve => setTimeout(resolve, 300));
    }

    await new Promise(resolve => setTimeout(resolve, 5000));

    for (let i = 0; i < set.length; i++) {
      set[i].classList.remove("logo-fade-in");
      set[i].classList.add("logo-fade-out");
    }

    await new Promise(resolve => setTimeout(resolve, 1000));
    container.style.opacity = 0;
    container.style.pointerEvents = 'none';
  }

  async function loopSets() {
    while (true) {
      await showSet(set1, container1);
      await showSet(set2, container2);
    }
  }

  loopSets();
});
